import type { SupabaseClient } from "@supabase/supabase-js";
import { createClient } from "@supabase/supabase-js";
import { getBackendKey, getBackendUrl, getClientOptions } from "./runtimeConfig";

let supabaseClient: SupabaseClient | null = null;

export const getSupabaseClient = () => {
  if (!supabaseClient) {
    supabaseClient = createClient(getBackendUrl(), getBackendKey(), getClientOptions());
  }
  return supabaseClient;
};
